exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".adr{margin-top:3px;color:#6c7378;font-size:.85em;width:90%}.adr .adr-break{display:block}.adr .country,.adr .singleline{display:none}.adr .preferred{margin:15px 0 7px}.adr .preferred span{padding:5px 10px;background-color:#eaf7e9;color:#2a5327;font-size:1em}.addressDisplay .adr .streets{display:inline;white-space:normal}.addressDisplay .adr .adr-break,.addressDisplay .adr .postal-code,.addressDisplay .adr .singleline,.addressDisplay .adr .streets,.addressDisplay .adr .streets+div{display:inline}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../~/less-loader!./components/xo-address-components/src/address-display/styles.less
 ** module id = 311
 ** module chunks = 1
 **/